// extracted by mini-css-extract-plugin
module.exports = {"container":"oH-z","productName":"pH-z","modal":"qH-z","dimensions":"rH-z","recipientEmail":"sH-z","lowStock":"tH-z","recommendedFit":"uH-z"};